// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3p750","toggle":"styles_toggle__7KLky","preview":"styles_preview__3OZ5g"};